var map = {
	"./black/luxiangjilu.png": "ApMk",
	"./blue/luxiangjilu.png": "Nl1P",
	"./white/luxiangjilu.png": "CEQ3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "xu4M";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/luxiangjilu\.png$
// module id = xu4M
// module chunks = 24